import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import MemberList from "./pages/MemberList";
import ClassSchedules from "./pages/ClassSchedules";
import ClassBookings from "./pages/ClassBookings";
import Payments from "./pages/Payments";
import Expenses from "./pages/Expenses";
import ProfitLoss from "./pages/ProfitLoss";
import DailyCashierReport from "./pages/DailyCashierReport";
import MonthlyDailyCashierReport from "./pages/MonthlyDailyCashierReport";
import MonthlyCashierReport from "./pages/MonthlyCashierReport";
import ConsignmentReport from "./pages/ConsignmentReport";
import Plans from "./pages/Plans";
import PtPackages from "./pages/PtPackages";
import CardioCoaches from "./pages/CardioCoaches";
import MasterProducts from "./pages/MasterProducts";
import ConsignmentProducts from "./pages/ConsignmentProducts";
import PointOfSale from "./pages/PointOfSale";
import TransactionCancel from "./pages/TransactionCancel";
import PettyCash from "./pages/PettyCash";
import ApproveReimburse from "./pages/ApproveReimburse";
import ProductPaymentRequests from "./pages/ProductPaymentRequests";
import PettyCashDeclaration from "./pages/PettyCashDeclaration";
import Merchants from "./pages/Merchants";
import MasterBanks from "./pages/MasterBanks";
import MasterBankAccounts from "./pages/MasterBankAccounts";
import Users from "./pages/Users";
import Orders from "./pages/Orders";
import Scan from "./pages/Scan";
import Branding from "./pages/Branding";
import FreezeApproval from "./pages/FreezeApproval";
import ContactUs from "./pages/ContactUs";
import Settings from "./pages/Settings";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <Dashboard />
              </ProtectedRoute>
            } />
            <Route path="/members" element={
              <ProtectedRoute allowedRoles={["kasir"]}>
                <MemberList />
              </ProtectedRoute>
            } />
            <Route path="/schedules" element={
              <ProtectedRoute allowedRoles={["kasir"]}>
                <ClassSchedules />
              </ProtectedRoute>
            } />
            <Route path="/class-bookings" element={
              <ProtectedRoute allowedRoles={["kasir"]}>
                <ClassBookings />
              </ProtectedRoute>
            } />
            <Route path="/payments" element={
              <ProtectedRoute allowedRoles={["kasir"]}>
                <Payments />
              </ProtectedRoute>
            } />
            <Route path="/expenses" element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <Expenses />
              </ProtectedRoute>
            } />
            <Route path="/profit-loss" element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <ProfitLoss />
              </ProtectedRoute>
            } />
            <Route path="/daily-report" element={
              <ProtectedRoute allowedRoles={["admin", "kasir"]}>
                <DailyCashierReport />
              </ProtectedRoute>
            } />
            <Route path="/cashier-monthly-report" element={
              <ProtectedRoute allowedRoles={["admin", "kasir"]}>
                <MonthlyDailyCashierReport />
              </ProtectedRoute>
            } />
            <Route path="/monthly-report" element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <MonthlyCashierReport />
              </ProtectedRoute>
            } />
            <Route path="/consignment-report" element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <ConsignmentReport />
              </ProtectedRoute>
            } />
            <Route path="/plans" element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <Plans />
              </ProtectedRoute>
            } />
            <Route path="/pt-menu" element={
              <ProtectedRoute allowedRoles={["admin", "kasir"]}>
                <PtPackages />
              </ProtectedRoute>
            } />
            <Route path="/cardio-coaches" element={
              <ProtectedRoute allowedRoles={["admin", "kasir"]}>
                <CardioCoaches />
              </ProtectedRoute>
            } />
            <Route path="/master-products" element={
              <ProtectedRoute allowedRoles={["admin", "kasir"]}>
                <MasterProducts />
              </ProtectedRoute>
            } />
            <Route path="/consignment-products" element={
              <ProtectedRoute allowedRoles={["kasir"]}>
                <ConsignmentProducts />
              </ProtectedRoute>
            } />
            <Route path="/pos" element={
              <ProtectedRoute allowedRoles={["kasir"]}>
                <PointOfSale />
              </ProtectedRoute>
            } />
            <Route path="/transaction-cancel" element={
              <ProtectedRoute allowedRoles={["admin", "kasir"]}>
                <TransactionCancel />
              </ProtectedRoute>
            } />
            <Route path="/petty-cash" element={
              <ProtectedRoute allowedRoles={["kasir"]}>
                <PettyCash />
              </ProtectedRoute>
            } />
            <Route path="/approve-reimburse" element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <ApproveReimburse />
              </ProtectedRoute>
            } />
            <Route path="/product-payment-requests" element={
              <ProtectedRoute allowedRoles={["admin", "kasir"]}>
                <ProductPaymentRequests />
              </ProtectedRoute>
            } />
            <Route path="/petty-cash-declaration" element={
              <ProtectedRoute allowedRoles={["admin", "kasir"]}>
                <PettyCashDeclaration />
              </ProtectedRoute>
            } />
            <Route path="/merchants" element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <Merchants />
              </ProtectedRoute>
            } />
            <Route path="/master-banks" element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <MasterBanks />
              </ProtectedRoute>
            } />
            <Route path="/master-rekening" element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <MasterBankAccounts />
              </ProtectedRoute>
            } />
            <Route path="/users" element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <Users />
              </ProtectedRoute>
            } />
            <Route path="/orders" element={
              <ProtectedRoute allowedRoles={["kasir"]}>
                <Orders />
              </ProtectedRoute>
            } />
            <Route path="/scan" element={
              <ProtectedRoute allowedRoles={["kasir"]}>
                <Scan />
              </ProtectedRoute>
            } />
            <Route path="/branding" element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <Branding />
              </ProtectedRoute>
            } />
            <Route path="/freeze-approval" element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <FreezeApproval />
              </ProtectedRoute>
            } />
            <Route path="/contact-us" element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <ContactUs />
              </ProtectedRoute>
            } />
            <Route path="/settings" element={
              <ProtectedRoute allowedRoles={["admin", "kasir"]}>
                <Settings />
              </ProtectedRoute>
            } />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;

